import React from 'react';
import { Link } from 'react-router-dom';
import "../assets/css/Footer.css";
import latestevent from '../assets/Gallery/aarambh4.jpg'
import insta2 from '../assets/Gallery/aarambh5.jpg'
import insta3 from '../assets/Gallery/aarambh6.jpg'
import insta4 from '../assets/Gallery/aarambh2.jpg'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* About Section */}
        <div className="footer-section">
          <h3>Office Address</h3>
          <p>407 Navale Icon. Navale Bridge, Vadgaon Bk - 411041, Pune, India</p>
          <p>+91 97306 10099 / 95033 70099</p>
          <p>contact@samriddhigurukul.com</p>
          <div className="newsletter">
            <input type="email" placeholder="Enter email address" />
            <button>&#10148;</button>
          </div>
        </div>

        {/* Latest News */}
        <div className="footer-section">
          <h3>Latest News</h3>
          <div className="news-item">
            <img src={latestevent} alt="event" />
            <div>
              <p>AARAMBH</p>
              <span>Feb. 13<sup>th</sup>2026</span>
            </div>
          </div>
          <div className="news-item">
            {/* <img src="/images/blue_horizon.jpg" alt="event" /> */}
            <div>
              {/* <p>lorem20 lorem lorem lorem </p> */}
              {/* <span>April. 09, 2025</span> */}
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="footer-section">
          <h3>Information</h3>
          <ul>
            <li><Link to="">About</Link></li>
            <li><Link to="">Franchise Opportunity</Link></li>
            <li><Link to="">Blog</Link></li>
            <li><Link to="">Contact</Link></li>
            <li><Link to="">Help & Support</Link></li>

          </ul>
        </div>

        {/* Instagram */}
        <a href='https://www.instagram.com/samriddhi_gurukulofficial/' className='insta_Link_footer'>
          <div className="footer-section">
            <h3>Instagram</h3>
            <div className="insta-grid">
              <img src={insta2} alt="insta1" />
              <img src={insta3} alt="insta2" />
              <img src={insta4} alt="insta3" />
              <img src={latestevent} alt="insta4" />
              <img src={insta3} alt="insta5" />
              <img src={insta4} alt="insta6" />
            </div>
          </div>

        </a>

      </div>

      {/* Bottom Footer */}
      <div className="footer-bottom">
        <p>Copyright ©2025 All rights reserved.</p>
        <p><a>samriddhigurukul.com</a></p>
      </div>
    </footer>
  );
};

export default Footer;
